import { useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router";
import { useFetchOverviewTables } from "src/store/overviewTables/useActions";
import { useOverviewTablesById } from "src/store/overviewTables/useSelectors";
import {
  NumberIndexedDictionary,
  StringIndexedDictionary,
} from "../../../../../../globalTypes";
import {
  RowKey,
  TableColumn,
  TableColumnInputType,
  TableColumns,
} from "../../../../../../requests/table/types";

// eslint-disable-next-line import/prefer-default-export
export const getColumnOrderByColumnName = (
  columnOrder: NumberIndexedDictionary<number> | undefined,
  columns: TableColumns
): StringIndexedDictionary<number> => {
  const res = {} as StringIndexedDictionary<number>;

  if (!columnOrder) {
    return res;
  }

  Object.entries(columnOrder).forEach(([templateItemId, order]) => {
    const foundCol = Object.entries(columns).find(
      ([ck, c]) => c.templateItemId === Number(templateItemId)
    );
    if (foundCol) {
      const [colName] = foundCol;

      res[colName] = order;
    }
  });

  return res;
};

const filterOverviewCols = (column: TableColumn) =>
  column.inputType === TableColumnInputType.OverviewSelect &&
  column.overviewSelectTemplateId !== null;

export const useFetchOverviewTablesFromColumns = (
  columnsByKey: TableColumns
): void => {
  const fetchOverviewTables = useFetchOverviewTables();
  const overviewTables = useOverviewTablesById();
  const getOverviewTemplateIds = () => {
    const columns = Object.values(columnsByKey);
    const overviewTemplateIds = columns
      .filter(filterOverviewCols)
      .map((col) => col.overviewSelectTemplateId ?? 0);
    return overviewTemplateIds.filter(
      (templateId) => !overviewTables[templateId]
    );
  };

  const overviewTemplateIds = useMemo(getOverviewTemplateIds, [
    columnsByKey,
    overviewTables,
  ]);

  useEffect(() => {
    if (overviewTemplateIds.length) {
      fetchOverviewTables(overviewTemplateIds);
    }
  }, [overviewTemplateIds, fetchOverviewTables]);
};
